import React from "react";
import { graphql, PageProps } from "gatsby";
import { RequestAQuotePageQuery } from "types/graphql-types";
import RequestAQuoteTemplate from "./RequestAQuoteTemplate";

const RequestAQuotePage: React.FC<PageProps<RequestAQuotePageQuery>> = (
  props
) => {
  return (
    <RequestAQuoteTemplate
      {...props}
      card={undefined}
      cruiseSuiteForm={undefined}
    />
  );
};

export const query = graphql`
  query RequestAQuotePage($languageCode: String) {
    page: sanityRequestAQuote(_id: { eq: "request-a-quote-page" }) {
      metadata {
        openGraph {
          ...OpenGraphMetaTags
        }
      }
      heading {
        ...PageBuilderOpeningText
      }
    }
    thankYouPageURL: sitePage(
      context: {
        sanityId: { regex: "/request-a-quote-thankyou-page$/" }
        languageCode: { eq: $languageCode }
      }
    ) {
      path
    }
  }
`;

export default RequestAQuotePage;
